import { SimulatorChannel } from "@/api/simulator/simulator.model";
import { Ticket03Icon } from "@/v2/assets/icons/Ticket03Icon";
import { Comment01Icon } from "@/v2/assets/icons/Comment01Icon";
import { SidebarRight } from "@/v2/assets/icons/SidebarRight";
import { Slack } from "@/v2/assets/icons/Slack";
import { Rotate3d } from "@/v2/assets/icons/3dRotate";

function getIcon(channel: SimulatorChannel) {
  switch (channel) {
    case "autonomous_ticket_event":
      return <Ticket03Icon size={16} fill="blue" />;
    case "autonomous_quackchat":
      return <Comment01Icon size={16} fill="orange" />;
    case "copilot":
      return <SidebarRight size={16} fill="teal" />;
    case "slackbot":
      return <Slack size={16} fill="purple" />;
    case "knowledge_hub":
      return <Rotate3d size={16} fill="cyan" />;
    default:
      return null;
  }
}

function getBackgroundColor(channel: SimulatorChannel) {
  switch (channel) {
    case "autonomous_ticket_event":
      return "#EDF6FF";
    case "autonomous_quackchat":
      return "rgba(255, 145, 1, 0.165)";
    case "copilot":
      return "rgba(2, 192, 150, 0.095)";
    case "slackbot":
      return "#FCEFFC";
    case "knowledge_hub":
      return "rgba(1, 204, 255, 0.114)";
    default:
      return "transparent";
  }
}

export function getChannelIconWithContainer(channel: SimulatorChannel) {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: getBackgroundColor(channel),
        borderRadius: "4px",
      }}
    >
      {getIcon(channel)}
    </div>
  );
}
